import ModCotizacion from "../mod_cotizacion";

export default function SubHeader({ usuario, color }) {
	return process.env.REACT_APP_TIPO &&
		process.env.REACT_APP_TIPO == "development" ? (
		<div
			className={`w-100 d-flex justify-content-between align-items-center p-1 text-end fondo-dev`}
			style={{ fontSize: "11px", backgroundColor: "#842029 !important" }}
		>
			<ModCotizacion tipo="minimized" />
			<h5 style={{ fontSize: "12px", padding: 0, margin: 0 }}>
				I´M {usuario.user.nombre.toUpperCase()}{" "}
				{usuario.user.apellido.toUpperCase()} MODO DEV
			</h5>
		</div>
	) : (
		<div
			className={`w-100 d-flex  justify-content-between align-items-center p-1 text-end`}
			style={{ fontSize: "11px", backgroundColor: color, color: "#fff" }}
		>
			<ModCotizacion tipo="minimized" />
			<h5 style={{ fontSize: "12px", padding: 0, margin: 0 }}>
				I´M {usuario.user.nombre.toUpperCase()}{" "}
				{usuario.user.apellido.toUpperCase()}
			</h5>
		</div>
	);
}